"use strict";

module.exports = require("gatsby-plugin-ts-config-cache/gatsby-browser");